import { useState } from "react";

export const useModal = () => {
    const [modalState, setModalState] = useState({
      isOpen: false,
      type: null,
      data: null,
    });
  
    const openModal = (type, data) => {
      setModalState({
        isOpen: true,
        type,
        data,
      });
    };
  
    const closeModal = () => {
      setModalState({
        isOpen: false,
        type: null,
        data: null,
      });
    };
  
    return {
      isOpen: modalState.isOpen,
      modalType: modalState.type,
      modalData: modalState.data,
      openModal,
      closeModal,
    };
  };